// extracted by mini-css-extract-plugin
module.exports = {"judgeBox":"Classes_judgeBox__NObPa","judgeBoxActive":"Classes_judgeBoxActive__yXAWw"};